module.exports = __webpack_public_path__ + "static/media/process_step3.34803951.svg";